import {
  AspectRatio,
  Body,
  HStack,
  Heading,
  Image,
  Radio,
  VStack,
  system,
  useRadio,
} from '@hover/blueprint';
import React from 'react';

type ProjectSelectionItem = Readonly<{
  value?: string;
  image?: string;
  label: string;
  description: string;
}>;

type ProjectSelectionTileProps = {
  item: ProjectSelectionItem;
};

export const ProjectSelectionTile = ({
  item,
  ...radioProps
}: ProjectSelectionTileProps) => {
  const { getInputProps, getLabelProps, state } = useRadio(radioProps);

  return (
    <HStack
      as="label"
      cursor="pointer"
      {...getLabelProps()}
      gap={{ base: 500 }}
      py={{ base: 400 }}
      w={1}
    >
      {item.image && (
        <AspectRatio
          borderRadius={300}
          overflow="hidden"
          ratio={1}
          width={{ base: '76px' }}
        >
          <Image
            alt="project-image"
            flex={1}
            height="100%"
            objectFit="cover"
            src={item.image}
            w="100%"
          />
        </AspectRatio>
      )}
      <system.input hidden {...getInputProps()} />
      <HStack
        data-testid="project-selection-tile"
        justifyContent="space-between"
        pr={100}
        w="1"
      >
        <VStack alignItems="flex-start" gap={0} justifyContent="center">
          <Heading m={0} textStyle="headingXs">
            {item.label}
          </Heading>
          <Body color="text.secondary" m={0} textStyle="bodySmall">
            {item.description}
          </Body>
        </VStack>
        <VStack
          alignItems="flex-start"
          spacing={0}
          sx={{ '&:empty': { display: 'none' } }}
        >
          <Radio
            checked={state.isChecked}
            inputProps={getInputProps()}
            value={item.value}
          />
        </VStack>
      </HStack>
    </HStack>
  );
};
